import {Component, inject, OnInit} from '@angular/core';
import {CommonService} from '../../../core/api/services/utility-services/common.service';
import {SessionDto} from '../../../core/models/session/sessiondto';
import {RoleConstants} from '../../../core/constants/role.constants';
import {TranslatePipe} from '@ngx-translate/core';
import {UrlConstants} from '../../../core/constants/url.constants';
import {RouterLink} from '@angular/router';
import {FeedbackService} from '../../../core/api/services/feedback/feedback.service';
import {LocaleService} from '../../../core/services/locale.service';
import {EventTypeConstants} from '../../../core/constants/event-type.constants';
import {EventLogReferrerConstants} from '../../../core/constants/event-log-referrer.constants';

@Component({
  selector: 'app-footer',
  imports: [
    TranslatePipe,
    RouterLink,
  ],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.css'
})
export class AppFooterComponent implements OnInit {
  year = new Date().getFullYear();
  sessionDetails:SessionDto;
  readonly commonService=inject(CommonService);
  readonly RoleConstants = RoleConstants;
  readonly UrlConstants = UrlConstants;
  readonly feedbackService = inject(FeedbackService);
  readonly localeService = inject(LocaleService);

  ngOnInit() {
    this.commonService.sessiondetails?.subscribe(res=>this.sessionDetails=res)
  }

  accessible(role:any):boolean{
    return this.sessionDetails && this.sessionDetails.userRoles?.includes(role);
  }

  onFeedbackLinkClick(): void {
    this.feedbackService.setSubmittedState(false);
  }

  openHelpPDF() {
    this.commonService.logEvent(EventTypeConstants.VIEW_FAQ, 'User is viewing the FAQ and Help resource', '', EventLogReferrerConstants.FOOTER);
    window.open('/crcWeb/file/' + this.localeService.getLocaleStr('_') + '/featured-items/Home-Ads/HS_CRCInstruction.pdf', '_blank');
  }

  showChangePassword() {
    return this.sessionDetails?.userName && (!this.accessible(RoleConstants.SHARED_PARTNER)) && !this.sessionDetails?.sharedPartnerUser
      && this.accessible(RoleConstants.VIEW_CHANGE_PASSWORD_PAGE) && !this.sessionDetails.ssouser && !this.sessionDetails.invokedByCrc
  }
}
